// components/Customer/ContactDrawer.js
import React from "react";
import { alpha, useTheme } from "@mui/material/styles";
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { useTranslation } from "react-i18next"; // Mantener la importación para asegurar la carga de configuraciones de i18n

const ContactDrawer = ({
  open,
  onClose,
  editContactId,
  newContact,
  handleContactChange,
  handleContactSubmit,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const accent = "#34afe2";

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 430,
          maxWidth: "100%",
          borderTopLeftRadius: 24,
          borderBottomLeftRadius: 24,
          borderLeft: `1px solid ${alpha(accent, 0.12)}`,
          background: `linear-gradient(180deg, ${alpha(
            theme.palette.common.white,
            0.96,
          )} 0%, ${alpha(theme.palette.background.paper, 0.98)} 100%)`,
        },
      }}
    >
      <Box sx={{ p: 1.4, borderBottom: `1px solid ${alpha(accent, 0.1)}` }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "0.7rem",
                fontWeight: 800,
                letterSpacing: 0.8,
                textTransform: "uppercase",
                color: "text.secondary",
              }}
            >
              CRM
            </Typography>
            <Typography sx={{ fontWeight: 900, fontSize: "1.35rem", lineHeight: 1 }}>
              {editContactId ? t("Contacts.Edit") : t("Contacts.Add")}
            </Typography>
            <Typography sx={{ mt: 0.35, fontSize: "0.8rem", color: "text.secondary" }}>
              Datos rápidos y rol del contacto
            </Typography>
          </Box>
          <IconButton
            onClick={onClose}
            sx={{
              border: "1px solid",
              borderColor: alpha(accent, 0.12),
              backgroundColor: alpha(theme.palette.common.white, 0.76),
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Box>
      </Box>

      <Box
        sx={{
          p: 1.5,
          display: "grid",
          gap: 1,
          "& .MuiOutlinedInput-root": {
            borderRadius: 3,
            backgroundColor: alpha(theme.palette.common.white, 0.82),
            boxShadow: `0 8px 18px ${alpha(theme.palette.common.black, 0.04)}`,
            "& fieldset": {
              borderColor: alpha(accent, 0.12),
            },
          },
        }}
      >

        <TextField
          name="firstName"
          label={t("Contacts.Name")}
          value={newContact.firstName}
          onChange={handleContactChange}
          fullWidth
          margin="dense"
        />
        <TextField
          name="lastName"
          label={t("Contacts.Apellido")}
          value={newContact.lastName}
          onChange={handleContactChange}
          fullWidth
          margin="dense"
        />
        <TextField
          name="phone"
          label={t("Contacts.Phone")}
          value={newContact.phone}
          onChange={handleContactChange}
          fullWidth
          margin="dense"
        />
        <TextField
          name="email"
          label={t("Contacts.Email")}
          value={newContact.email}
          onChange={handleContactChange}
          fullWidth
          margin="dense"
        />
        <TextField
          name="position"
          label={t("Contacts.Position")}
          value={newContact.position}
          onChange={handleContactChange}
          fullWidth
          margin="dense"
        />

        <Button
          onClick={handleContactSubmit}
          variant="contained"
          sx={{
            background: `linear-gradient(135deg, ${accent} 0%, ${alpha(
              accent,
              0.82,
            )} 100%)`,
            color: theme.palette.getContrastText(accent),
            marginTop: 2,
            width: "100%",
            padding: "11px 0",
            fontWeight: "800",
            borderRadius: 999,
            boxShadow: `0 14px 30px ${alpha(accent, 0.24)}`,
          }}
        >
          {editContactId ? t("Clientes.Actualizar") : t("Clientes.Add")}
        </Button>
      </Box>
    </Drawer>
  );
};

export default ContactDrawer;
